// Accounts workspace design tokens: the dashboard's own Foxbeep theme (C), through the finance
// tokens, so Accounts looks like the rest of the admin dashboard. Only three Accounts-specific
// names are added, all derived from the same theme. Same export names as src/finance/ui/tokens.js.
import { C } from "../core";
import { T as FT } from "../../finance/ui/tokens";

export const T = {
    ...FT,
    accent: C.accent2,              // eyebrow text, used sparingly
    warningBg: C.yellow + "1f",     // tinted warning surface on the dark theme
    figures: FT.font,
};

export { text, surface, control, button } from "../../finance/ui/tokens";

// ─── Formatting (same as finance) ──────────────────────────────────────────
export { money, fmtDay, fmtDateTime, monthShort, period } from "../../finance/ui/tokens";

export const PAYMENT_METHODS = [
    ["bank_transfer", "Bank transfer"],
    ["cash", "Cash"],
    ["card", "Card"],
    ["digital_wallet", "Digital wallet"],
    ["cheque", "Cheque"],
    ["other", "Other"],
];
export const methodLabel = (m) => (PAYMENT_METHODS.find(([k]) => k === m) || [null, "—"])[1];
